import { jsx as _jsx } from "react/jsx-runtime";
import Save16 from '@carbon/icons-react/es/save/16';
import { Button } from 'components/atoms/button/button';
export const SaveButton = (props)=>/*#__PURE__*/ _jsx(Button, {
        icon: /*#__PURE__*/ _jsx(Save16, {}),
        type: "primary",
        iconPlacement: "right",
        ...props
    });
